var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg137Eraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,471.981H234.001l188.016-184.734c7.879-7.741,7.99-20.404,0.249-28.283c-7.742-7.879-20.405-7.99-28.283-0.249 l-50.084,49.21l-139.96-139.763L320.277,51.697c15.597-15.596,40.973-15.596,56.569,0l83.438,83.438 c15.596,15.596,15.596,40.973,0,56.569c-7.811,7.811-7.811,20.474,0,28.284c7.811,7.81,20.474,7.811,28.284,0 c31.192-31.192,31.192-81.945,0-113.137L405.13,23.412C373.938-7.78,323.186-7.78,291.985,23.42L23.432,292.267 C8.322,307.377,0,327.466,0,348.835c0,21.312,8.277,41.351,23.311,56.447l80.59,83.166c0.086,0.089,0.174,0.178,0.262,0.265 c14.948,14.861,34.788,23.124,55.865,23.266c0.186,0.001,0.368,0.002,0.553,0.002c0.986,0,1.97-0.018,2.951-0.053 c0.485,0.035,0.975,0.053,1.469,0.053h327c11.046,0,20-8.954,20-20C512.001,480.935,503.046,471.981,492,471.981z  M132.482,460.462l-80.545-83.118c-0.073-0.075-0.146-0.15-0.221-0.224C44.161,369.564,40,359.519,40,348.835 c0-10.685,4.161-20.729,11.724-28.292l123.947-124.082L315.365,335.96L188.337,460.77 C172.827,475.732,147.819,475.586,132.482,460.462z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg137Eraser);
export default __webpack_public_path__ + "static/media/137-eraser.973eecde486bc5702f6c4f3d5e367de9.svg";
export { ForwardRef as ReactComponent };